<template>
  <div class="block-counter" data-time="@@time">
      <div :class="'block-counter__inner-wrapper' + ((days != '00') ? ' with-days' : '')">
          <div class="block-counter__text">
              <h2>YOUR {{entryType | uppercase }} {{ startsOrEnds | uppercase }} IN …</h2>
          </div>
          <div class="block-counter__time">
              <div v-if="days != '00'" class="block-counter__time-item">
                  <div class="time-item time-day">
                      <span>{{days}}</span>
                  </div>
                  <span class="time-type">DAYS</span>
              </div>
              <div class="block-counter__time-item">
                  <div class="time-item time-hour">
                      <span>{{hours}}</span>
                  </div>
                  <span class="time-type">HOURS</span>
              </div>
              <div class="block-counter__time-item">
                  <div class="time-item time-minute">
                      <span>{{minutes}}</span>
                  </div>
                  <span class="time-type">MINUTES</span>
              </div>
              <div class="block-counter__time-item">
                  <div class="time-item time-second">
                      <span>{{seconds}}</span>
                  </div>
                  <span class="time-type">SECONDS</span>
              </div>
          </div>
      </div>
  </div>
</template>


<script>
import _ from 'lodash'

export default {
  name: 'Timer',
  props: ['time', 'entryType', 'startsOrEnds'],
  computed: {},
  data() {
    return {
      days: "",
      hours: "",
      minutes: "",
      seconds: ""
    }
  },
  created() {
    const self = this;
    setInterval(function () {
      self.calculateParts()
    }, 1000)
  },
  methods: {
    calculateParts() {
      const dist = new Date(this.time) - this.$store.state.currentTime
      this.days = _.padStart(Math.floor(dist / (1000 * 60 * 60 * 24)), 2, '0')
      this.hours = _.padStart(Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 2, '0')
      this.minutes = _.padStart(Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60)), 2, '0')
      this.seconds = _.padStart(Math.floor((dist % (1000 * 60)) / 1000), 2, '0')
    },
  }

}
</script>


<style lang="scss" scoped>
</style>
